import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import Navbar from "@/components/Navbar";
import Hero from "@/components/Hero";
import Bio from "@/components/Bio";
import Music from "@/components/Music";
import Clips from "@/components/Clips";
import Gallery from "@/components/Gallery";
import Concerts from "@/components/Concerts";
import Shop from "@/components/Shop";
import Press from "@/components/Press";
import Contact from "@/components/Contact";
import Footer from "@/components/Footer";
import FloatingPlayer from "@/components/FloatingPlayer";

const Home = () => (
  <div className="App bg-[#050505]">
    <Navbar />
    <main>
      <Hero />
      <Bio />
      <Music />
      <Clips />
      <Gallery />
      <Concerts />
      <Shop />
      <Press />
      <Contact />
    </main>
    <Footer />
    <FloatingPlayer />
  </div>
);

function App() {
  return (
    <BrowserRouter>
      <Toaster position="top-center" theme="dark" richColors />
      <Routes>
        <Route path="/" element={<Home />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
